import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Skeletons } from 'ui/components/skeleton';

import { Report } from 'services/action';
import * as Fi from 'react-icons/fi';

export const Action = ({ customer, isLoading, type  }) => {
  const Dispatch = useDispatch();

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleDownload = async() => {
    const params = {
      downloadable: true,
      type: type,
    }

    await Dispatch(Report.$agingCustomer(customer?.id, params));
  }

  return (
    <div className="d-flex align-items-center gap-1 px-md-3 px-2  px-md-0 pb-2 pb-md-0">
      {isLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Download XLS</Tooltip>}
        >
          <button
            className='btn btn-info px-2'
            onClick={() => $handleDownload()}
          >
            <Fi.FiDownloadCloud size="17"/>
          </button>
        </OverlayTrigger>
      )}
    </div>
  );
};
